import partnerBusinessService from "../services/partner/business";
import whitelabelBusinessService from "../services/whitelabel/business";
import config from "../../config/config";

export default {
  namespaced: true,
  state: {
    isFetchWaiting: true,
    list: [],
    fetchError: null,
  },
  getters: {
    isFetchWaiting: (state) => state.isFetchWaiting,
    list: (state) => state.list,
    fetchError: (state) => state.fetchError,
  },
  mutations: {
    setList(state, businesses) {
      state.isFetchWaiting = false;
      state.list = businesses;
    },
    setFetchError(state, message) {
      state.isFetchWaiting = false;
      state.fetchError = message;
    },
  },
  actions: {
    async fetchBusinesses({ state, commit }, activeAccount) {
      state.isFetchWaiting = true;
      try {
        if (!activeAccount) throw new Error("Bad State");
        let businesses = [];
        if (!config.whitelabelMode)
          businesses = await partnerBusinessService.getPartnerBusinesses(
            activeAccount.id
          );
        else
          businesses = await whitelabelBusinessService.getBusinesses(
            activeAccount.id
          );
        commit("setList", businesses);
      } catch (error) {
        console.error(error);
        commit("setFetchError", error.message);
      }
    },
    async clearBusinesses({ commit, state }) {
      commit("setList", []);
      commit("setFetchError", null);
      state.isFetchWaiting = true;
    },
    async updateToPremium(_x, { accountId, business, discountCode }) {
      if (config.whitelabelMode) {
        await whitelabelBusinessService.updateBusinessToPremium(
          accountId,
          business,
          discountCode
        );
      } else {
        await partnerBusinessService.updateBusinessToPremium(
          accountId,
          business
        );
      }
    },
  },
};
